import { Link, NavLink } from "react-router";
import { Building2, Globe, Landmark, Layers } from "lucide-react";

import { classnames } from "../fwk/helpers";
import { SymbolSearch } from "../symbols";

/**
 * The app's global destinations, in menu order.
 */
const MENU_ITEMS = [
  { to: "/market", label: "Market", icon: Globe },
  { to: "/sectors", label: "Sectors", icon: Layers },
  { to: "/indexes", label: "Indexes", icon: Landmark },
  { to: "/stocks", label: "Stocks", icon: Building2, end: true },
];

const MenuLink = ({ item }) => {
  const Icon = item.icon;
  return (
    <NavLink
      to={item.to}
      end={item.end}
      className={({ isActive }) =>
        classnames(
          "mono flex min-h-10 items-center gap-2 px-3 no-underline",
          isActive ? "bg-rust text-cream hover:text-cream" : "text-cream hover:bg-slate-hover hover:text-white",
        )
      }
    >
      <Icon className="size-3.5" />
      {item.label}
    </NavLink>
  );
};

/**
 * Slate top band: brand, global destinations and the symbol search.
 */
export const NavMenu = () => {
  return (
    <header className="sticky top-0 z-30 bg-slate px-4 text-cream md:px-8">
      <div className="mx-auto flex min-h-[60px] max-w-[1280px] flex-wrap items-center gap-x-7 gap-y-2 py-2">
        <Link to="/" className="dsp text-[26px] font-black tracking-[0.02em] text-cream no-underline hover:text-white">
          New<span className="text-rust-light">/</span>Statements
        </Link>
        <nav aria-label="Main" className="flex flex-wrap gap-0.5">
          {MENU_ITEMS.map((item) => (
            <MenuLink key={item.to} item={item} />
          ))}
        </nav>
        <SymbolSearch />
      </div>
    </header>
  );
};
